<template>
	<div>
		<el-row>
			<el-col>
				<el-form :inline='true'>
					<el-form-item label="关键字：" >
						<el-input placeholder="发票抬头/姓名/手机号" v-model="filters.keyWord" clearable></el-input>
					</el-form-item>
					<el-form-item  label="发票类型：" >
						<el-select v-model="filters.invoiceType" placeholder="请选择发票类型" clearable>
							<el-option
									v-for="item in invoiceType"
									:key="item.value"
									:label="item.label"
									:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item  label="开票状态：" >
						<el-select v-model="filters.invoiceStatus" placeholder="请选择开票状态" clearable>
							<el-option
									v-for="item in invoiceStatus"
									:key="item.value"
									:label="item.label"
									:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
          <el-form-item label="票种">
            <el-select v-model="filters.sflzfp" clearable>
              <el-option
                v-for="item in sflzfp"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                >
              </el-option>
            </el-select>
          </el-form-item>
					<el-form-item  label="开票日期：" >
						<el-date-picker
								v-model="filters.monthData"
								type="daterange"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="">
						<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<!-- 列表 -->
		<el-table
				:data="tableData"
				border
				style="width: 100%"
				v-loading="listLoading"
				@current-change='currentChange'
				:highlight-current-row='true'
		>
			<el-table-column type='index' label="序号" width='60' align="center"></el-table-column>
			<el-table-column prop="Name" label="姓名" width="120" align="center"></el-table-column>
			<el-table-column prop="PhoneNumber" label="手机号" width="" align="center"></el-table-column>
			<el-table-column prop="Email" label="邮箱" width="" align="center"></el-table-column>
      <el-table-column prop="Sflzfp" label="票种" width="" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.Sflzfp">蓝票</el-tag>
          <el-tag type="danger" v-else>红票</el-tag>
        </template>
      </el-table-column>/
			<el-table-column prop="InvoiceType" label="发票类型" width="" align="center">
				<template scope="scope">
					<el-tag type='danger' v-if='scope.row.InvoiceType === 2'>电子普票</el-tag>
					<el-tag type='success' v-else-if='scope.row.InvoiceType === 1'>电子专票</el-tag>
					<text  v-else>-</text>
				</template>
			</el-table-column>
			<el-table-column prop="InvoiceTitleType" label="抬头类型" width="" align="center">
				<template scope="scope">
					<el-tag type='danger' v-if='scope.row.InvoiceTitleType === 1'>企业</el-tag>
					<el-tag type='success' v-else-if='scope.row.InvoiceTitleType === 2'>个人</el-tag>
					<text  v-else>-</text>
				</template>
			</el-table-column>
			<el-table-column prop="InvoiceTitle" label="发票抬头" width="" align="center"></el-table-column>
			<el-table-column prop="CompanyTaxNumber" label="公司税号" width="" align="center"></el-table-column>
			<el-table-column prop="InvoiceMoney" label="开票金额" width="" align="center"></el-table-column>
			<el-table-column prop="CreateTime" label="申请时间" width="" align="center"></el-table-column>
			<el-table-column prop="InvoiceCreateTime" label="开票时间" width="" align="center"></el-table-column>
			<el-table-column prop="InvoiceStatus" label="开票状态" width="" align="center">
				<template scope="scope">
					<el-tag type='danger' v-if='scope.row.InvoiceStatus === 0'>未开</el-tag>
					<el-tag type='danger' v-if='scope.row.InvoiceStatus === 1'>开票中</el-tag>
					<el-tag type='success' v-else-if='scope.row.InvoiceStatus === 2'>已开票</el-tag>
					<text  v-else>-</text>
				</template>
			</el-table-column>
		  <el-table-column label="操作" width="150" align="center">
		    <template scope="scope">
		      <el-button v-if="scope.row.InvoiceStatus===2" type="text" @click="downloadReport(scope.row)">下载发票</el-button>
		      <el-button v-else type="text" >-</el-button>
		    </template>
		  </el-table-column>

		</el-table>
		<!--底部工具条-->
		<el-col :span="24" class="pageBar" style="height: 80px;margin-top: 12px">
			<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pages.pageIndex"
					:page-sizes="pages.pageArr"
					:page-size="pages.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pages.dataCount">
			</el-pagination>
		</el-col>
	</div>
</template>

<script>
import util from "../../../util/date";
import Toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
import {
	downloadProjectReport, getProjectInformation, getOrderInvoiceInfoListPage, exportInvoiceInfoData
} from '@/api/api'
export default {
	components:{Toolbar},
	data() {
		return {
			buttonList: [],
			needData: '',
			filters:{
				keyWord:undefined,//关键字
				invoiceType:undefined,//发票类型：（1：电子专票、2：电子普票）
				invoiceStatus:undefined,//开票状态：（0：未开、1：开票中、2：已开票）
				monthData:undefined,//开票时间
        sflzfp: undefined // 票种
			},
			tableData: [],
			invoiceType:[
				{
					label:'电子普票',
					value:2
				},
					{
					label:'电子专票',
					value:1
				}
			],
			invoiceStatus:[
				{
					label:'未开',
					value:0
				},
					{
					label:'开票中',
					value:1
				},
					{
					label:'已开票',
					value:2
				}
			],
			listLoading: false,
			//关于分页的obj
			pages: {
				pageSize: 20,//默认每页条数
				pageArr: [10, 20, 30, 40],//默认每页条数选择
				pageIndex: 1, //默认进入页
				dataCount: 20, //默认总页数
			},
      //发票类型
      sflzfp: [
        {
          value: true,
          label: "蓝票"
        },
        {
          value: false,
          label: "红票"
        }
      ]
		}
	},
	methods: {
		callFunction(item) {
			this[item.Func].apply(this, item);
		},
		getDataList(){
			this.listLoading = true
			console.log(this.filters.monthData,'monthdata')
			let params = {
				keyWord:this.filters.keyWord,//关键字
				invoiceType:this.filters.invoiceType,//发票类型：（1：电子专票、2：电子普票）
				invoiceStatus:this.filters.invoiceStatus,//开票状态：（0：未开、1：开票中、2：已开票）
				invoiceCreateStartTime: this.filters.monthData ? this.filters.monthData[0]+' '+'00:00:00': undefined,
				invoiceCreateEndTime: this.filters.monthData ? this.filters.monthData[1]+' '+'00:00:00' : undefined,
        sflzfp: this.filters.sflzfp,
				pageIndex: this.pages.pageIndex,
				pageSize: this.pages.pageSize,
			}

			getOrderInvoiceInfoListPage(params).then(res => {
				var result = res.data
				if(result.Success){
					this.listLoading = false;
					this.pages.dataCount = result.Response.DataCount
					this.pages.pageIndex = result.Response.PageIndex
					if(result.Response.PageSize > 0){
						this.pages.pageSize = result.Response.PageSize
					}
					this.tableData = result.Response.Data
					console.log(this.tableData,'tbaledata')
				}else{
					this.listLoading = false
				}
			})
		},
		// 查询
		getListData() {
			this.pages.pageIndex = 1
			this.pages.pageSize = 20
			this.getDataList();
		},
		// 下载
		downloadReport(row) {
			window.open(row.InvoiceDownloadUrl)
		},
		handleFileDownload(response) {
			// 从headers中获取文件名（处理UTF-8编码）
			// const contentDisposition = response.headers['content-disposition'];
			// console.log(contentDisposition,'cccccccc')
			// const fileNameMatch = contentDisposition.match(/filename\*=UTF-8''(.+)/);
			const fileName = '发票导出明细.xlsx'
			// const fileName = fileNameMatch
			// 		? decodeURIComponent(fileNameMatch[1])
			// 		: 'downloaded_file.xlsx';

			// 创建Blob对象
			let blob = new Blob([response.data], {type: "content-type"})

			// 创建临时链接并触发下载
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.download = fileName;
			link.style.display = 'none';

			document.body.appendChild(link);
			link.click();

			// 清理资源
			document.body.removeChild(link);
			window.URL.revokeObjectURL(link.href);
		},

		// 导出
		export() {
			let params = {
				keyWord:this.filters.keyWord,//关键字
				invoiceType:this.filters.invoiceType,//发票类型：（1：电子专票、2：电子普票）
				invoiceStatus:this.filters.invoiceStatus,//开票状态：（0：未开、1：开票中、2：已开票）
				invoiceCreateStartTime: this.filters.monthData ? this.filters.monthData[0]+' '+'00:00:00': undefined,
				invoiceCreateEndTime: this.filters.monthData ? this.filters.monthData[1]+' '+'00:00:00' : undefined,
			}
			exportInvoiceInfoData(params).then(res => {
				this.handleFileDownload(res)
			})
		},
		// 点击table某一行
		currentChange(val) {
			this.needData = val
		},

		// 分页
		handleCurrentChange(val) {
			this.pages.pageIndex = val;
			this.getDataList();
		},
		handleSizeChange(val){
			this.pages.pageSize = val;
			this.getDataList();
		},
		// 时间格式化
		formatCreateTime: function(row, column) {
			return !row.CreateTime || row.CreateTime == ""
					? ""
					: util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
		},
		// 筛选项input框清空
		handleClear(){

		},
		// 获取当前时间
		getLastSomeDay() {
			var currentDate = new Date();  // 获取当前时间
			var previousDate = new Date(currentDate);  // 复制当前时间对象
			previousDate.setDate(currentDate.getDate());  // 将日期设置为前一天
			// this.filters.monthData = this.formatCreateTimeDay1(previousDate)
			// this.getDataList();
			this.filters.monthData = new Date()
			this.getDataList()
		},
		formatCreateTimeDay1: function(row, column) {
			return !row || row == ""
					? ""
					: util.formatDate.format(new Date(row), "yyyy-MM-dd");
		},
		getMonthFirstOrEndDay(type,val) {
			// 获取当月的第一天
			if(type == 1) {
				var date = val
				date.setDate(1)
				return date.toLocaleDateString()
			}
			// 获取当月的最后一天
			if(type == 2) {
				const date = new Date(val);
				const year = date.getFullYear();
				const month = date.getMonth() + 1;
				return year + (month < 10 ? '-0' : '-') + month + '-' + new Date(year, month, 0).getDate();
			}
			// 获取当年第一天
			if(type == 3) {
				var date = val
				return this.formatCreateTimeDay1(date).split("-")[0] + "-01-01"
			}
			// 获取当年最后一天
			if(type == 4) {
				var date = val
				return this.formatCreateTimeDay1(date).split("-")[0] + "-12-31"
			}
		},
		rowClass({columnIndex}){
			return 'padding:8px 0!important;'
		},
	},
	watch: {

	},
	created(){
		let routers = window.localStorage.router
				? JSON.parse(window.localStorage.router)
				: [];
		this.buttonList = getButtonList(this.$route.path, routers);
		this.getListData()
	},
	mounted() {
		// this.getLastSomeDay()
	}
}
</script>

<style lang="stylus" scoped>

</style>
